// extracted by mini-css-extract-plugin
export default {"matrix_display_area_div":"matrixDisplayArea_matrix_display_area_div__jfnhX"};